/** @jsx jsx */

import { ComponentProps, Fragment } from 'react';
import { isEmpty } from 'lodash';

import { Icon } from '@zapier/zinnia-icons';
import { Accordion, Spacer } from '@zapier/design-system';
import { css, jsx } from '@emotion/core';

import { getGuideStepsBySection, isSectionComplete } from 'app/cli-guide/utils';

import Items from './Items';

const Styles = {
  root: css`
    & details {
      background: inherit !important;
      border: none !important;
      box-shadow: none !important;
    }
    & details > summary::before {
      inset: 0px;
    }
  `,
  title: css`
    align-items: center;
    display: flex;
  `,
};

type Props = ComponentProps<typeof Items> & {
  openSections?: {};
  sections: Array<string>;
};

const Sections = (props: Props) => {
  const {
    currentStep,
    disabledSteps,
    onSelectStep,
    openSections,
    sections,
    steps,
    stepsSeen,
  } = props;

  return isEmpty(sections) ? (
    <ul>
      <Items
        currentStep={currentStep}
        disabledSteps={disabledSteps}
        onSelectStep={onSelectStep}
        steps={steps}
        stepsSeen={stepsSeen}
      />
    </ul>
  ) : (
    <Fragment>
      {sections
        .map(section => ({
          title: section,
          steps: getGuideStepsBySection(section, steps),
        }))
        .map(section => {
          const isSectionDone = isSectionComplete(
            section.title,
            steps,
            stepsSeen
          );
          const isSectionOpen = openSections[section.title] !== false;

          return (
            <div css={Styles.root} key={section.title}>
              <Accordion
                isInitiallyOpen={isSectionOpen}
                title={
                  <div css={Styles.title}>
                    {section.title}
                    <Spacer width="1rem" />
                    {isSectionDone && (
                      <Icon
                        color="UiPrimaryStrongest"
                        name="formCheckCircle"
                        size={18}
                      />
                    )}
                  </div>
                }
                toggleSide="left"
              >
                <ul>
                  <Items
                    currentStep={currentStep}
                    disabledSteps={disabledSteps}
                    onSelectStep={onSelectStep}
                    steps={section.steps}
                    stepsSeen={stepsSeen}
                  />
                </ul>
              </Accordion>
            </div>
          );
        })}
    </Fragment>
  );
};

export default Sections;
